<template>
  <componantContent/>
</template>

<script>
import componantContent from '@/components/_manageroleapprover/_update/update.vue'
export default {
  components: {
    componantContent
  }
}
</script>
